import { MutationTree } from 'vuex';
import { NavigationState } from './types';

const mutations: MutationTree<NavigationState> = {
  setReceivedAppsCount(state, receivedAppsCount: number) {
    state.receivedAppsCount = receivedAppsCount;
  },
  setUnreadMessageCount(state, count: number) {
    state.unreadMessageCount = count;
  },
};

export default mutations;
